import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import classNames from 'classnames'
import {isStatusOk} from '@/utils'
import {EcospendBankBlock, EcospendBlock, EcospendField, EcospendText, EcospendPayeeBlock} from '..'
import {EcospendResultPageProps} from './props'
import styles from './EcospendResultPage.scss'
import {Button, Icon} from '@/components'
import { Typography } from 'antd'

export const EcospendResultPage = observer((props: EcospendResultPageProps) => {
    const { t } = useTranslation()
    const {friendlyName, message, bankReferenceId, status, invoiceId, amount, closeEcospendModal, tryAgain, payee} = props
    const isOk = isStatusOk(status)

    const renderMessage = () => {
        if (isOk) return t('EcospendResultPage.successMessage')
        if (message) return message
        switch (status) {
            case 'Canceled':
                return t('EcospendResultPage.cancelMessage')
            case 'Failed':
                return t('EcospendResultPage.failMessage')
            case 'Rejected':
                return t('EcospendResultPage.rejectMessage')
            default:
                return ''
        }
    }

    return <div className={styles.ecospendResultPage}>
        <Icon type={isOk ? 'check' : 'close'}
              className={classNames(styles.resultIcon, {[styles.hasError]: !isOk})}/>

        <h3 className={classNames(styles.title, {[styles.errorTitle]: !isOk})}>
            {isOk ? t('EcospendResultPage.successTitle') : status}
        </h3>

        <EcospendText className={styles.subtitle}>{renderMessage()}</EcospendText>

        {bankReferenceId ? <EcospendBlock className={styles.largeBlock}>
            <EcospendField label={t('EcospendResultPage.transactionId')}>
                <div className={styles.transactionContent}>
                    <Typography.Text
                        className={styles.copyText}
                        copyable
                    >
                        {bankReferenceId}
                    </Typography.Text>
                </div>
            </EcospendField>
        </EcospendBlock> : null}

        <EcospendBankBlock
            friendlyName={friendlyName}
            invoiceId={invoiceId}
            amount={amount}
            className={styles.block}
        />

        <EcospendPayeeBlock payee={payee} className={styles.payeeBlock}/>

        <div className={styles.buttons}>
            {isOk ?
                <Button type={'link'} onClick={() => closeEcospendModal()}
                        className={styles.button}>{t('EcospendResultPage.returnToBack')}</Button>
                : <Button type={'link'} onClick={() => tryAgain()}
                          className={styles.button}>{t('EcospendResultPage.tryAgain')}</Button>
            }
        </div>

        <EcospendText
            className={styles.footertext}
        >
            <Trans
                i18nKey='Ecospend.footerText'
                components={{ a: <a href={'https://register.fca.org.uk/s/firm?id=0010X00004KSo9HQAT'} target="_blank" rel="noreferrer" /> }}
            />
        </EcospendText>
    </div>
})
